<div class="content-block">

    <div class="sifrarnik-vrste-problema-list-container">
      <vrste-problema-tablica [type]="tipVrsteProblema"></vrste-problema-tablica>
    </div>
    
</div>
